var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',[_vm._t("default",function(){return [_c('v-btn',_vm._b({class:_vm.className,attrs:{"outlined":"","block":""},domProps:{"innerHTML":_vm._s(_vm.label)}},'v-btn',_vm.$attrs,false))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }